<template>
    <ModalComponent
        name="bloquearButacas"
        title="Bloquear / Liberar butacas"
        @close="$emit('close')"
    >
    <b-row>
        <b-col cols="12 mb-3">
            <EtiquetaComponent @seleccionada="(etiquetaSeleccionada) => etiqueta = etiquetaSeleccionada" />
        </b-col>
        <b-col cols="12">
            <FormInput label="Concepto" v-model="concepto" />
        </b-col>
        <b-col cols="12" class="mt-2">
            <h4>BUTACAS A BLOQUEAR / LIBERAR:</h4>
        </b-col>
        <b-col cols="12" class="mt-2">
            <b-card>
                <b-card-body class="p-0">
                    <div v-for="(butaca, index) in butacas" :key="index">
                        <div class="d-flex align-items-center" >
                            <h5 class="mb-0 p-1">
                                <template>
                                    {{ index + 1 }}.
                                    <span v-if="butaca.sector_name">
                                        Sector: {{ butaca.sector_name }} -
                                    </span>
                                </template>
                        
                                <span v-if="butaca.fila">
                                    Fila: {{ butaca.fila }} - Butaca: {{ butaca.butaca }}
                                </span>
                        
                                <template v-if="butaca.numeroPlaza">
                                    Plaza: {{ butaca.numeroPlaza }}
                                </template>

                                <template v-if="butaca.asiento?.fila && butaca.asiento?.asiento">
                                    <span v-if="butaca.asiento?.zona_nombre">
                                        Zona: {{ butaca.asiento.zona_nombre }}
                                    </span>
                                    <span>
                                        Fila: {{ butaca.asiento.fila }}
                                    </span>
                                    <span>
                                        Asiento: {{ butaca.asiento.asiento }}
                                    </span>
                                </template>
                            </h5>
                        </div>
                    </div>
                </b-card-body>
            </b-card>
        </b-col>
        <b-col cols="12" class="text-right">
            <Button class="m-1" @click="bloquearButacas()">Bloquear / Liberar</Button>
        </b-col>
    </b-row>
    </ModalComponent>
</template>

<script>
import ModalComponent from "@/components/backend/components/ModalComponent";
import EtiquetaComponent from '@/views/backend/events/sesiones/bloquear-asientos/EtiquetaComponent.vue';

export default {
    props: {
        butacas: {
            type: Array,
            required: true
        }
    },
    data() {
        return {
            concepto: null,
            etiqueta: null
        }
    },
    methods: {
        bloquearButacas() {
            this.$emit('bloquearButacas', this.concepto, this.etiqueta);
        }
    },
    components: { ModalComponent, EtiquetaComponent }
}
</script>